import { Validators } from '@angular/forms';
import { ParentingTestType } from '@app/modules/service-data/types/paternity.types';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';

// Validators of the additional participants (FormArray) are set in
// ServiceDataFormComponent, because their number depends on the bundle
export const paternityValidationSet: ValidationPair = {
  children: {
    paternity: {
      children: {
        parentingTestType: {
          validators: [Validators.required],
        },
        relationship: {
          validators: [Validators.required],
        },
      },
      validators: [
        crossFieldValidator(
          'patientHistory.isSameBiologicalMother',
          'parentingTestType',
          ParentingTestType.Fraternity
        ),
        crossFieldValidator(
          'patientHistory.wantToKnow',
          'parentingTestType',
          ParentingTestType.Fraternity
        ),
      ],
    },
    shared: {
      children: {
        patientGender: {
          validators: [Validators.required],
        },
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
      },
    },
  },
};
